import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  municipios:[],
};
export const mutations = {
  FILL_MUNICIPIOS({ context }, municipios) {
    let lista_municipios = [];
    if (municipios) {
      Object.entries(municipios).forEach(([key, val]) => lista_municipios.push(val));
      return (state.municipios = lista_municipios);
    }
  }
};
export const actions = {
    GET_MUNICIPIOS({ commit }, data) {
        return new Promise((resolve, reject) => {
          commit("SET_LOADING", true);
          ApiService.get(data)
            .then(response => {
              commit("SET_LOADING", false);
              commit("FILL_MUNICIPIOS", response.data.data.municipios);
              resolve(response);
            })
            .catch(error => {
              commit("SET_LOADING", false);
              reject(error);
            });
        });
      },
};

export const getters = {
  listMunicipios: state => state.municipios,
};
